import type { ReactNode } from 'react'

import { Stack, Typography } from '@mui/material'

interface Props {
  label: ReactNode
  action1?: ReactNode
  action2?: ReactNode
  action3?: ReactNode
}

export function FieldHeader(props: Props) {
  const { label, action1 = null, action2 = null, action3 = null } = props

  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center" height={31}>
      <Typography noWrap variant="h6">
        {label}
      </Typography>
      <Stack direction="row">
        {action1}
        {action2}
        {action3}
      </Stack>
    </Stack>
  )
}
